/**
 * Форматирует номер телефона для отображения.
 *
 * Неразрушающий: уже отформатированное значение лишь «причёсывается» — скобки и
 * дефисы заменяются на пробел, повторяющиеся пробелы схлопываются. Точки
 * сохраняются («доб.тел.», разделители групп), как и «+», запятая (несколько
 * номеров), слэш, буквы.
 *
 * Группировка цифр с конца (2-2-3-3) применяется ТОЛЬКО к «сырым» значениям —
 * сплошной строке из одних цифр (например, мобильный из старой CRM). Иначе мы бы
 * переформатировали уже структурированный номер и поломали коды города (см.
 * `8 (83176) 5-25-85` — код 83176, а не «8 + 3176»).
 *
 * Примеры:
 *   89279992222                            → 8 927 999 22 22
 *   79991234567                            → 7 999 123 45 67
 *   (8552) 44-36-66, +7 (987) 224-68-56    → 8552 44 36 66, +7 987 224 68 56
 *   8 (83176) 5-25-85                      → 8 83176 5 25 85
 *   8(495) 505-93-33 доб.тел. 25-54        → 8 495 505 93 33 доб.тел. 25 54
 *
 * Строки без цифр возвращаются без изменений.
 */
export function formatPhone(value: string): string {
  const trimmed = value.trim();

  // Сплошная строка из одних цифр — «сырой» номер (обычно мобильный из старой
  // CRM). Группируем с конца, чтобы читалось.
  if (/^\d+$/.test(trimmed)) {
    const groups: string[] = [];
    let remaining = trimmed;

    for (const size of [2, 2, 3, 3]) {
      if (!remaining) break;
      if (remaining.length <= size) {
        groups.unshift(remaining);
        remaining = '';
        break;
      }
      groups.unshift(remaining.slice(-size));
      remaining = remaining.slice(0, -size);
    }

    if (remaining) groups.unshift(remaining);

    return groups.join(' ');
  }

  // Уже отформатировано человеком: скобки и дефисы заменяем на пробел (не удаляем —
  // иначе цифры склеятся, как в баге «85524436667 987 224 68 56»), схлопываем
  // пробелы. Точки, «+», запятая, слэш, буквы остаются как есть.
  const cleaned = trimmed.replace(/[()\-]/g, ' ').replace(/\s+/g, ' ').trim();

  // Без цифр — оставить исходное значение без изменений.
  if (!/\d/.test(cleaned)) return value;

  return cleaned;
}
